<template>
    <div v-show="elementShown" class="container hidable-home-title" :class="cssClasses">
        <div class="row">
            <div class="col-12">
                <h2>
                    Bioscopen
                </h2>
            </div>
        </div>
    </div>
</template>

<script>
    import HidableElement from '../mixins/HidableElement';

    export default {
        mixins: [
            HidableElement,
        ],
        data() {
            return {
                cssClasses: '',
            };
        },
        mounted() {
            // Show/hide the element based on the event
            VueEvents.$on('movie_results_amount', amount => {
                this.cssClasses = (amount > 0) ? 'mt-12' : '';
            });
        },
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/home/HidableHomeCinemasTitle.vue